/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} barev`
};

const da_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} farver`
};

const de_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} Farben`
};

const en_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} color(s)`
};

const es_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} colores`
};

const fr_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} coloris`
};

const hu_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} szín`
};

const it_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} colori`
};

const nl_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} kleuren`
};

const pl_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} kolorów`
};

const pt_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} cores`
};

const sv_n_colors = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} färger`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const n_colors = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.n_colors(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("n_colors", locale)
	if (locale === "cs") return cs_n_colors(inputs)
	if (locale === "da") return da_n_colors(inputs)
	if (locale === "de") return de_n_colors(inputs)
	if (locale === "en") return en_n_colors(inputs)
	if (locale === "es") return es_n_colors(inputs)
	if (locale === "fr") return fr_n_colors(inputs)
	if (locale === "hu") return hu_n_colors(inputs)
	if (locale === "it") return it_n_colors(inputs)
	if (locale === "nl") return nl_n_colors(inputs)
	if (locale === "pl") return pl_n_colors(inputs)
	if (locale === "pt") return pt_n_colors(inputs)
	return sv_n_colors(inputs)
};